var render, staticRenderFns
import script from "./fundChart.vue?vue&type=script&lang=tsx&"
export * from "./fundChart.vue?vue&type=script&lang=tsx&"
import style0 from "./fundChart.vue?vue&type=style&index=0&id=c2ff85ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ff85ba",
  null
  
)

export default component.exports